export default __webpack_public_path__ + "static/media/cm.eb4cbbfe.svg";